const config = {
  // API Base URL
  API_BASE_URL: "https://dev.admin.askbud-i.com/api/v1/admin/",
  API_BASE_URL_V1: "https://dev.admin.askbud-i.com/api/v1",
  CLIENT_API_BASE_URL: "https://dev.client.askbud-i.com/api/v1",
  // API_BASE_URL: "http://127.0.0.1:8000/api/v1/admin/",
  // API_BASE_URL_V1: "http://127.0.0.1:8000/api/v1",
  // CLIENT_API_BASE_URL: "http://127.0.0.1:8000/api/v1",
  CRON_SECRET: process.env.REACT_APP_CRON_SECRET || "your-cron-secret",
  // API_BASE_URL: "https://admin.askbud-i.com/api/v1/admin/",
  // API_BASE_URL_V1: "https://admin.askbud-i.com/api/v1",
  //  API_BASE_URL: "http://127.0.0.1:8000/api/v1/admin/",
  //  API_BASE_URL_V1: "http://127.0.0.1:8000/api/v1",

  // Admin user data (will be populated after login)
  user: null,
  adminUserId: null,
  adminUserRole: null,
  adminUserEmail: null,

  // Initialize config from localStorage
  init: function () {
    if (typeof window !== 'undefined') {
      try {
        const adminUserData = localStorage.getItem('adminUserData');
        if (adminUserData) {
          const parsedData = JSON.parse(adminUserData);
          this.setUserData(parsedData);
        }

        // Also make it available globally for backward compatibility
        if (!window.appConfig) {
          window.appConfig = this;
        }
      } catch (error) {
        console.error('Error initializing config:', error);
      }
    }
  },

  // Update config with new admin user data
  setUserData: function (userData) {
    this.user = userData;
    this.adminUserId = userData.admin_user_id;
    this.adminUserRole = userData.role;
    this.adminUserEmail = userData.email_id;

    console.log('Config updated with:', {
      adminUserId: this.adminUserId,
      adminUserRole: this.adminUserRole,
      adminUserEmail: this.adminUserEmail
    });

    // Also update localStorage
    if (typeof window !== 'undefined') {
      localStorage.setItem('adminUserData', JSON.stringify(userData));
      window.appConfig = this;
    }
  },

  // Clear admin user data on logout
  clearUserData: function () {
    this.user = null;
    this.adminUserId = null;
    this.adminUserRole = null;
    this.adminUserEmail = null;

    if (typeof window !== 'undefined') {
      localStorage.removeItem('adminUserData');
      window.appConfig = this;
    }
  },

  // Get headers for API calls with Bearer token
  getHeaders: function (additionalHeaders = {}) {
    const token = localStorage.getItem('adminToken');
    const headers = {
      'Content-Type': 'application/json',
      ...additionalHeaders
    };

    // Add Authorization header if token exists
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  },

  // Check if admin user is authenticated
  isAuthenticated: function () {
    const hasAdminUserId = !!this.adminUserId;
    const hasToken = !!localStorage.getItem('adminToken');

    console.log('Admin auth check:', {
      hasAdminUserId,
      hasToken,
      adminUserId: this.adminUserId
    });

    return hasAdminUserId && hasToken;
  }
};

// Initialize config when module is loaded
if (typeof window !== 'undefined') {
  config.init();
}

export default config;